const GooglePlayWhite = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 117 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_dddd_5739_24241)">
        <rect
          x="0.415541"
          y="0.415541"
          width="115.52"
          height="40.723"
          rx="2.90878"
          stroke="#FFF9F3"
          strokeWidth="0.831081"
        />
      </g>
      <path
        d="M39.0025 14.4855V15.2418H40.7477C40.7145 16.2474 39.8834 16.9372 38.8861 16.9372C37.6894 16.9372 36.9248 16.0479 36.9248 14.6351C36.9248 13.2223 37.6811 12.333 38.8695 12.333C39.7504 12.333 40.4319 12.8233 40.5982 13.6295H41.5123C41.3212 12.3746 40.3239 11.5435 38.8612 11.5435C37.1076 11.5435 36.0023 12.7901 36.0023 14.6351C36.0023 16.4801 37.1159 17.7267 38.8113 17.7267C39.659 17.7267 40.3156 17.3943 40.7394 16.8042L40.8973 17.5938H41.5788V14.4855H39.0025ZM46.3564 15.4828C46.3564 14.1946 45.6167 13.2056 44.3202 13.2056C43.0985 13.2056 42.2841 14.1032 42.2841 15.4496C42.2841 16.8292 43.1235 17.6935 44.3368 17.6935C45.3674 17.6935 46.0406 17.1117 46.2566 16.2806H45.4173C45.2677 16.7128 44.9103 16.9954 44.3535 16.9954C43.6637 16.9954 43.1983 16.5965 43.1235 15.7238H46.3564V15.4828ZM44.3202 13.9037C45.0183 13.9037 45.4256 14.4024 45.5004 15.0673H43.1318C43.2398 14.2777 43.6969 13.9037 44.3202 13.9037ZM48.8942 13.9869V13.3054H48.0299V12.0754H47.1988V13.3054H46.509V13.9869H47.1988V16.638C47.1988 17.3527 47.6144 17.6187 48.3873 17.6187C48.5369 17.6187 48.7114 17.6104 48.8942 17.5938V16.9289H48.5202C48.1546 16.9289 48.0299 16.8125 48.0299 16.5632V13.9869H48.8942ZM51.2324 12.6987H52.0801V11.8094H51.2324V12.6987ZM51.2407 17.5938H52.0718V13.3054H51.2407V17.5938ZM55.0381 13.9869V13.3054H54.1737V12.0754H53.3427V13.3054H52.6529V13.9869H53.3427V16.638C53.3427 17.3527 53.7582 17.6187 54.5311 17.6187C54.6807 17.6187 54.8552 17.6104 55.0381 17.5938V16.9289H54.6641C54.2984 16.9289 54.1737 16.8125 54.1737 16.5632V13.9869H55.0381ZM60.0773 17.7267C61.8142 17.7267 62.9611 16.4801 62.9611 14.6351C62.9611 12.7901 61.8142 11.5435 60.0773 11.5435C58.332 11.5435 57.1851 12.7901 57.1851 14.6351C57.1851 16.4801 58.332 17.7267 60.0773 17.7267ZM60.0773 16.9289C58.8888 16.9289 58.1076 16.0479 58.1076 14.6351C58.1076 13.2223 58.8888 12.3413 60.0773 12.3413C61.2574 12.3413 62.0386 13.2223 62.0386 14.6351C62.0386 16.0479 61.2574 16.9289 60.0773 16.9289ZM65.8349 13.2056C65.2282 13.2056 64.7711 13.5215 64.4886 13.9453V13.3054H63.6907V17.5938H64.5218V15.1753C64.5218 14.311 65.0952 13.937 65.6022 13.937C66.184 13.937 66.5081 14.2196 66.5081 14.8346V17.5938H67.3392V14.7182C67.3392 13.7375 66.7657 13.2056 65.8349 13.2056Z"
        fill="white"
      />
      <path
        d="M40.3787 25.4364V26.7046H42.5429C42.4614 27.9147 41.4492 28.7175 40.2275 28.7175C38.6684 28.7175 37.7027 27.5889 37.7027 25.7622C37.7027 23.9355 38.6451 22.8069 40.1693 22.8069C41.3096 22.8069 42.1357 23.4119 42.3684 24.3776H43.9856C43.7064 22.5858 42.252 21.4339 40.1577 21.4339C37.6329 21.4339 36.0621 23.1559 36.0621 25.7622C36.0621 28.3685 37.6329 30.0905 40.0181 30.0905C41.1816 30.0905 42.1357 29.6367 42.7174 28.8106L42.9385 29.9043H44.0787V25.4364H40.3787ZM48.0417 30.0439C49.8684 30.0439 51.0901 28.8106 51.0901 26.9024C51.0901 24.9943 49.8684 23.7609 48.0417 23.7609C46.2149 23.7609 44.9816 24.9943 44.9816 26.9024C44.9816 28.8106 46.2149 30.0439 48.0417 30.0439ZM48.0417 28.8339C47.0876 28.8339 46.4826 28.1707 46.4826 26.9024C46.4826 25.6342 47.0876 24.971 48.0417 24.971C48.9841 24.971 49.6008 25.6342 49.6008 26.9024C49.6008 28.1707 48.9841 28.8339 48.0417 28.8339ZM54.8023 30.0439C56.629 30.0439 57.8507 28.8106 57.8507 26.9024C57.8507 24.9943 56.629 23.7609 54.8023 23.7609C52.9756 23.7609 51.7423 24.9943 51.7423 26.9024C51.7423 28.8106 52.9756 30.0439 54.8023 30.0439ZM54.8023 28.8339C53.8482 28.8339 53.2432 28.1707 53.2432 26.9024C53.2432 25.6342 53.8482 24.971 54.8023 24.971C55.7448 24.971 56.3614 25.6342 56.3614 26.9024C56.3614 28.1707 55.7448 28.8339 54.8023 28.8339ZM63.0988 23.9006V24.7267C62.7032 24.1216 62.0749 23.7609 61.2023 23.7609C59.5617 23.7609 58.5029 24.9826 58.5029 26.821C58.5029 28.6477 59.585 29.881 61.2139 29.881C62.0516 29.881 62.6567 29.5436 63.0523 28.9851V29.7414C63.0523 30.6839 62.5403 31.1958 61.5746 31.1958C60.7718 31.1958 60.3064 30.87 60.2366 30.2301H58.7938C58.8869 31.475 59.8177 32.3244 61.5513 32.3244C63.506 32.3244 64.5183 31.2889 64.5183 29.7065V23.9006H63.0988ZM61.5397 28.671C60.5972 28.671 60.0039 27.9961 60.0039 26.8326C60.0039 25.6691 60.5972 24.971 61.5397 24.971C62.4938 24.971 63.0872 25.6226 63.0872 26.821C63.0872 28.0078 62.4938 28.671 61.5397 28.671ZM65.7016 29.9043H67.1676V21.6201H65.7016V29.9043ZM74.0154 27.0071C74.0154 25.099 72.8868 23.7609 71.0484 23.7609C69.2682 23.7609 68.0815 25.0175 68.0815 26.9024C68.0815 28.8222 69.3031 30.0439 71.0717 30.0439C72.5144 30.0439 73.5616 29.2644 73.8641 28.0427H72.4563C72.2352 28.5779 71.7814 28.9037 71.0833 28.9037C70.234 28.9037 69.6289 28.4266 69.5242 27.3562H74.0154V27.0071ZM71.0368 24.9012C71.9094 24.9012 72.433 25.4829 72.5494 26.3323H69.5359C69.6755 25.3433 70.2572 24.9012 71.0368 24.9012ZM81.1963 21.6201H77.5545V29.9043H79.1253V27.0071H81.1963C83.1045 27.0071 84.1284 25.9134 84.1284 24.3194C84.1284 22.7138 83.1045 21.6201 81.1963 21.6201ZM81.1265 25.6575H79.1253V22.9698H81.1265C82.0457 22.9698 82.546 23.4584 82.546 24.3194C82.546 25.1804 82.0457 25.6575 81.1265 25.6575ZM84.9609 29.9043H86.427V21.6201H84.9609V29.9043ZM93.0071 29.9043C92.8442 29.6716 92.7628 29.1946 92.7628 28.7641V25.5644C92.7628 24.4823 92.053 23.7609 90.2612 23.7609C88.388 23.7609 87.6433 24.5405 87.5619 25.8087H89.0046C89.0628 25.0757 89.4118 24.8546 90.2496 24.8546C91.0989 24.8546 91.3433 25.1339 91.3433 25.5993C91.3433 26.0414 91.0524 26.216 90.4939 26.2858L89.5864 26.3672C87.8876 26.5301 87.2826 27.2399 87.2826 28.2405C87.2826 29.404 88.1669 30.0439 89.4468 30.0439C90.331 30.0439 90.9826 29.7298 91.3782 29.1713C91.4015 29.4622 91.448 29.7414 91.5411 29.9043H93.0071ZM89.7958 28.9968C89.121 28.9968 88.7835 28.6826 88.7835 28.1823C88.7835 27.7053 89.0512 27.4144 89.8656 27.3213L90.6568 27.2282C90.971 27.1933 91.192 27.1235 91.3433 26.9839V27.5307C91.3433 28.5779 90.5754 28.9968 89.7958 28.9968ZM97.5061 23.9006L97.0174 25.4131C96.6916 26.4719 96.3658 27.5656 96.0517 28.7524C95.7492 27.5773 95.4234 26.4487 95.0976 25.4015L94.6089 23.9006H93.0266L94.7718 28.8339C94.9114 29.2295 95.0511 29.6832 95.0511 30.0439C95.0511 30.5442 94.7835 31.0096 94.0621 31.0096H93.5036V32.1615C93.6898 32.1848 93.8643 32.1964 94.1435 32.1964C95.5979 32.1964 96.2495 31.731 96.7265 30.393L99.0419 23.9006H97.5061Z"
        fill="white"
      />
      <g filter="url(#filter1_ii_5739_24241)">
        <path
          d="M11.1889 9.922C10.9471 10.178 10.8041 10.5752 10.8041 11.0897V29.4699C10.8041 29.9851 10.9471 30.3816 11.1889 30.6375L11.2504 30.6974L21.5467 20.4011V20.2798V20.1584L11.2504 9.86133L11.1889 9.922Z"
          fill="url(#paint0_linear_5739_24241)"
        />
        <path
          d="M24.9783 23.8348L21.5467 20.4016V20.2803V20.1589L24.9791 16.7266L25.0564 16.7706L29.1229 19.081C30.2839 19.7409 30.2839 20.8205 29.1229 21.4812L25.0564 23.7916L24.9783 23.8348Z"
          fill="url(#paint1_linear_5739_24241)"
        />
        <g filter="url(#filter2_i_5739_24241)">
          <path
            d="M25.0563 23.7898L21.5458 20.2793L11.1888 30.6371C11.5711 31.0426 12.2036 31.0925 12.9158 30.6886L25.0563 23.7898Z"
            fill="url(#paint2_linear_5739_24241)"
          />
        </g>
        <path
          d="M25.0563 16.7691L12.9158 9.8711C12.2036 9.46637 11.5711 9.51706 11.1888 9.92263L21.5466 20.2804L25.0563 16.7691Z"
          fill="url(#paint3_linear_5739_24241)"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddd_5739_24241"
          x="-42.3851"
          y="-14.9595"
          width="201.122"
          height="126.325"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.24205" />
          <feGaussianBlur stdDeviation="0.959769" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0268173 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5739_24241" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.43412" />
          <feGaussianBlur stdDeviation="2.65364" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0399899 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_5739_24241" result="effect2_dropShadow_5739_24241" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.26804" />
          <feGaussianBlur stdDeviation="6.38894" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0582218 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_5739_24241" result="effect3_dropShadow_5739_24241" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="27.4257" />
          <feGaussianBlur stdDeviation="21.1926" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="effect3_dropShadow_5739_24241" result="effect4_dropShadow_5739_24241" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_5739_24241" result="shape" />
        </filter>
        <filter
          id="filter1_ii_5739_24241"
          x="10.8041"
          y="9.5918"
          width="19.1895"
          height="21.375"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.124662" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5739_24241" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.124662" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_innerShadow_5739_24241" result="effect2_innerShadow_5739_24241" />
        </filter>
        <filter
          id="filter2_i_5739_24241"
          x="11.1888"
          y="20.2793"
          width="13.8674"
          height="10.6875"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.124662" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5739_24241" />
        </filter>
        <linearGradient
          id="paint0_linear_5739_24241"
          x1="20.634"
          y1="10.8952"
          x2="6.6868"
          y2="24.8424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5739_24241"
          x1="30.6342"
          y1="20.2803"
          x2="10.5254"
          y2="20.2803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5739_24241"
          x1="23.1498"
          y1="22.1857"
          x2="4.23569"
          y2="41.0999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5739_24241"
          x1="8.58041"
          y1="3.80404"
          x2="17.0261"
          y2="12.2497"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GooglePlayWhite
